import { ReactNode, useMemo } from 'react';

// material-ui
import { alpha, useTheme } from '@mui/material/styles';
import { AppBar, AppBarProps, Toolbar, useMediaQuery } from '@mui/material';

// project import
import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent';
import IconButton from 'components/@extended/IconButton';

// assets
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { sizeByBreakpoint } from '../../../utils/helper';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

interface Props {
  open: boolean;
  handleDrawerToggle?: () => void;
}

const Header = ({ open, handleDrawerToggle }: Props) => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down('lg'));

  // header content
  const headerContent = useMemo(() => <HeaderContent />, []);

  // const iconBackColorOpen = theme.palette.mode === 'dark' ? 'grey.200' : 'grey.300';
  // const iconBackColor = theme.palette.mode === 'dark' ? 'background.default' : 'grey.100';

  // common header
  const mainHeader: ReactNode = (
    <Toolbar
      sx={{
        minHeight: 60,
        height: 60,
        px: '0 !important',
        '@media (min-width: 768px)': { paddingLeft: 0, paddingRight: 0 },
        borderBottom: '1px solid',
        borderColor: (theme) => theme.palette.border.main
      }}
    >
      <IconButton
        aria-label="open drawer"
        onClick={handleDrawerToggle}
        color="primary"
        sx={{
          width: sizeByBreakpoint(1.5, 36),
          height: sizeByBreakpoint(1.5, 36),
          borderColor: 'transparent !important',
          color: open ? theme.palette.primary.main : theme.palette.text.primary,
          bgcolor: open ? alpha(theme.palette.primary.main, 0.2) : theme.palette.background.default,
          ml: 0
        }}
      >
        {!open ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
      </IconButton>
      {headerContent}
    </Toolbar>
  );

  // app-bar params
  const appBar: AppBarProps = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      px: 4,
      [theme.breakpoints.down('md')]: {
        px: 2
      }
    }
  };

  return (
    <>
      {!matchDownMD ? (
        <AppBarStyled open={open} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  );
};

export default Header;
